import React from 'react';
// Analytics
import { usePageTracking } from '../../hooks/useAnalytics';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import CommercialsPageMainContainer from '../../components/commercials/CommercialsPageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import CommercialsPageHeader from '../../components/commercials/CommercialsPageHeader';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  commercialsPageAdditionalMeta,
  commercialsPageStructuredData,
} from '../../utils/data/MetaData';
import SampleVideo720 from '../../assets/video/commercial-sample-video-siv-renate-720.mp4';
import SampleVideo1080 from '../../assets/video/commercial-sample-video-siv-renate-1080.mp4';
import Poster from '../../assets/images/posters/commercial-sample-video-siv-renate-poster.webp';

const CommercialsPage = React.memo(() => {
  usePageTracking();

  return (
    <>
      <HelmetItem
        PageName='Commercials'
        desc={`${CompanyName} — explore Siv Renate’s commercials and UGC portfolio. Authentic storytelling, creative media editing, and impactful visual content for brands and clients worldwide.`}
        keywords={`Siv Renate, ${CompanyName}, commercials, UGC creator, portfolio, media editing, brand storytelling, Drammen Norway`}
        additionalMeta={commercialsPageAdditionalMeta}
        structuredData={commercialsPageStructuredData}
        links={[
          {
            rel: 'preload',
            as: 'video',
            href: SampleVideo720,
            type: 'video/mp4',
          },
          {
            rel: 'preload',
            as: 'video',
            href: SampleVideo1080,
            type: 'video/mp4',
            media: '(min-width: 1024px)',
          },
          { rel: 'preload', as: 'image', href: Poster },
        ]}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation + header */}
          <div className='grid relative grid-rows-reg min-h-screen h-screen max-h-screen'>
            <Navbar />
            <CommercialsPageHeader />
          </div>

          {/* Main page content */}
          <CommercialsPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
});

export default CommercialsPage;
